import { isString } from 'lodash';
import { FieldPath, FieldValues, useWatch } from 'react-hook-form';

import { useFormContext } from '@/components/react-hook-form';

export function useRemainingCharacters<
  T extends FieldValues,
  TFieldName extends FieldPath<T>,
>(fieldName: TFieldName, limit: number) {
  const { control } = useFormContext<T>();
  const value = useWatch<T>({ control, name: fieldName });

  if (!isString(value)) {
    return {
      helpText: `${limit} characters remaining`,
      remaining: limit,
      // remainingExact can go negative once the limit is exceeded; `remaining`
      // is clamped to 0 for callers that only want a non-negative count.
      remainingExact: limit,
      isOverLimit: false,
    };
  }

  const remainingExact = limit - value.length;
  const remaining = Math.max(0, remainingExact);
  const isOverLimit = value.length > limit;
  return {
    helpText: `${remaining} characters remaining`,
    remaining,
    remainingExact,
    isOverLimit,
  };
}
